(function () {
  var MIN_SIMILARITY = 0.32;
  var MIN_WORD_LEN = 3;

  function normalize(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function bigrams(str) {
    var set = new Set();
    var s = str.replace(/\s+/g, '');
    for (var i = 0; i < s.length - 1; i++) set.add(s.substr(i, 2));
    return set;
  }

  function diceCoefficient(a, b) {
    var bgA = bigrams(a);
    var bgB = bigrams(b);
    if (bgA.size === 0 || bgB.size === 0) return 0;
    var intersection = 0;
    bgA.forEach(function (bg) { if (bgB.has(bg)) intersection++; });
    return (2 * intersection) / (bgA.size + bgB.size);
  }

  function textMatches(query, text) {
    var q = normalize(query);
    var t = normalize(text);
    if (!q || !t) return false;

    if (t.indexOf(q) > -1 || q.indexOf(t) > -1) return true;

    var textWords = t.split(' ').filter(function (w) { return w.length >= MIN_WORD_LEN; });
    var queryWords = q.split(' ').filter(function (w) { return w.length >= MIN_WORD_LEN; });

    for (var i = 0; i < queryWords.length; i++) {
      for (var j = 0; j < textWords.length; j++) {
        if (textWords[j].indexOf(queryWords[i]) > -1 || queryWords[i].indexOf(textWords[j]) > -1) return true;
      }
    }

    return diceCoefficient(q, t) >= MIN_SIMILARITY;
  }

  // Matches on product name OR a specific tag/color value (e.g. "Red"), never on
  // description/body text, so junk tags like "AI"/"N8N" can't cause false positives
  // (they're too short to pass the word-length or similarity checks).
  function isRelevant(query, title, tagsString) {
    if (textMatches(query, title)) return true;

    if (tagsString) {
      var tags = tagsString.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      for (var i = 0; i < tags.length; i++) {
        if (tags[i].length >= MIN_WORD_LEN && textMatches(query, tags[i])) return true;
      }
    }

    return false;
  }

  function getQueryFromUrl() {
    return new URLSearchParams(window.location.search).get('q') || '';
  }

  // Full /search results page
  function filterSearchPage() {
    var query = getQueryFromUrl();
    if (!query) return;

    var productList = document.querySelector('.main-search product-list, .main-search .product-list');
    if (!productList) return;

    var cards = productList.querySelectorAll('.product-card');
    var visibleCount = 0;

    cards.forEach(function (card) {
      var titleEl = card.querySelector('.product-title');
      var title = titleEl ? titleEl.textContent : '';
      var tags = card.getAttribute('data-tags') || '';
      if (isRelevant(query, title, tags)) {
        card.style.removeProperty('display');
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    var countEl = document.querySelector('.section-header p');
    if (countEl) {
      countEl.textContent = (visibleCount === 1
        ? mdT('smart_search_filter.results_one', '{count} result for "{query}"')
        : mdT('smart_search_filter.results_other', '{count} results for "{query}"'))
        .replace('{count}', visibleCount).replace('{query}', query);
    }

    var existingEmpty = document.querySelector('.smart-search-empty-state');
    if (existingEmpty) existingEmpty.remove();

    if (visibleCount === 0) {
      var empty = document.createElement('div');
      empty.className = 'empty-state smart-search-empty-state';
      empty.innerHTML = '<div class="v-stack gap-4"><p>' +
        mdT('smart_search_filter.no_results', 'No results found for "{query}". Try a different search term.')
          .replace('{query}', query.replace(/</g, '&lt;')) + '</p></div>';
      productList.replaceWith(empty);
    }
  }

  // Header predictive-search dropdown
  function watchPredictiveSearch() {
    var content = document.querySelector('.predictive-search__content');
    var input = document.querySelector('.header-search__input');
    if (!content || !input) return;

    var timer = null;

    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var query = input.value;
        var productsWrap = content.querySelector('.predictive-search__products');
        if (!productsWrap || !query) return;

        var existingMsg = productsWrap.querySelector('.smart-search-no-results');
        if (existingMsg) existingMsg.remove();

        var cards = productsWrap.querySelectorAll('.predictive-search-product');
        var visibleCount = 0;

        cards.forEach(function (card) {
          var titleEl = card.querySelector('.product-title');
          var title = titleEl ? titleEl.textContent : '';
          var tags = card.getAttribute('data-tags') || '';
          if (isRelevant(query, title, tags)) {
            card.style.removeProperty('display');
            visibleCount++;
          } else {
            card.style.display = 'none';
          }
        });

        if (visibleCount === 0 && cards.length > 0) {
          productsWrap.insertAdjacentHTML(
            'beforeend',
            '<p class="predictive-search__no-results smart-search-no-results text-lg">No matching products.</p>'
          );
        }
      }, 60);
    });

    observer.observe(content, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    filterSearchPage();
    watchPredictiveSearch();
  });
})();